'use client';

/**
 * Legacy-only: clears the legacy pending trade flow cookie when the finish-trade screen mounts in a terminal state (SUCCESS/FAILED).
 * Remove this file when legacy operation URLs are retired.
 * See trade/AccepBackwardsCompatibilityInterceptor/legacy-freeze/README.md
 */

import { useEffect, type ReactNode } from 'react';
import { clearLegacyPendingTradeFlowKeyAction } from '../../CreateTrade/legacy-freeze/legacyPendingTradeFlowCookie.actions';

const LEGACY_FINISH_TRADE_SUCCESS_STATUSES = new Set<string>([
  'FINISHED',
  'CREATED',
  'ACTIVE',
  'SUCCESS',
]);

function isLegacyTerminalFinishTradeStatus(
  status: string | undefined,
): boolean {
  if (!status) return false;

  if (status === 'FAILED') return true;

  return LEGACY_FINISH_TRADE_SUCCESS_STATUSES.has(status);
}

export function LegacyFinishTradeKeyClearOnMount({
  status,
  children,
}: {
  status: string | undefined;
  children: ReactNode;
}) {
  useEffect(() => {
    if (isLegacyTerminalFinishTradeStatus(status)) {
      clearLegacyPendingTradeFlowKeyAction();
    }
  }, []);

  return <>{children}</>;
}
